<template>
	<div class="hello">

	</div>
</template>

<script>
	import * as THREE from 'three';
	import CameraControls from 'camera-controls';
	import {
		BDVar
	} from '@/scene/BDVar.js'
	CameraControls.install({
		THREE: THREE
	});
	
	import {
		BloomEffect,
		GodRaysEffect,
		EffectPass,
		RenderPass as RP,
		EffectComposer as EC
	} from "postprocessing";

	// const paramsBloom = {
	// 	exposure: 0.9,
	// 	bloomStrength: 0.3,
	// 	bloomThreshold: 0.7,
	// 	bloomRadius: 1
	// };
	const paramGodRay = {
		resolutionScale: 0.1,
		density: 2.9, //辐射长度
		decay: 0.9, //辐射内圈长度
		weight: 1,
		samples: 500,
	}
	const paramCloud = {
		resolutionScale: 1,
		density: 8.5, //辐射长度
		decay: 0.9, //辐射内圈长度
		weight: 0.5,
		samples: 500,
	}
	var uniforms = null;
	var canvasDom = null;
	var container = null
	export default {
		name: 'Earth',
		props: {
			msg: String
		},
		mounted() {
			this.initScene();
		},
		methods: {
			initScene() {
				var _this = this;
				BDVar.mouse = new THREE.Vector2();
				BDVar.raycaster = new THREE.Raycaster();
				BDVar.scene = new THREE.Scene()
				BDVar.renderer = new THREE.WebGLRenderer()
				BDVar.camera = new THREE.PerspectiveCamera(60, 1920 / 886, 1, 100000)
				BDVar.scene.add(BDVar.camera)
				
				// BDVar.renderer.autoClear = false
				container = document.getElementsByClassName('hello')[0]
				//设置尺寸
				this.resetSize(null)
				container.appendChild(BDVar.renderer.domElement);
				container.style.touchAction = 'none';
				container.addEventListener('pointermove', this.onPointerMove, false);
				BDVar.renderer.setClearColor(0x000000, 1); //87CEEB
				BDVar.renderer.render(BDVar.scene, BDVar.camera);
				
				BDVar.camera.position.x = -346.23665400201594;
				BDVar.camera.position.y = 29.62027244599948;
				BDVar.camera.position.z = -331.4631486088808;
				BDVar.clock = new THREE.Clock();
				var cameraLightGroup = new THREE.Group();

				BDVar.cameraControls = new CameraControls(BDVar.camera, BDVar.renderer.domElement);
				BDVar.cameraControls.verticalDragToForward = true;
				BDVar.cameraControls.dampingFactor = 1
				BDVar.cameraControls.draggingDampingFactor = 1;
				BDVar.cameraControls.mouseButtons.left = CameraControls.ACTION.ROTATE;
				BDVar.cameraControls.mouseButtons.right = CameraControls.ACTION.ROTATE;
				// BDVar.cameraControls.maxPolarAngle = Math.PI / 2;
				// BDVar.cameraControls.minPolarAngle = 0;
				// BDVar.cameraControls.minDistance = 0;
				// BDVar.cameraControls.maxDistance = 20000;



				this.addLight()

				this.animation();

				var imageLoader = new THREE.TextureLoader();
				
				

				
				
				//星云
				var cloud = this.cloud(imageLoader)
				var cloud2 = this.cloud(imageLoader)

				cloud.position.set(0, -4000, 10000);
				cloud.rotation.set(0, 0, -Math.PI / 1.2)
				cloud.scale.set(50, 50, 50)
				cloud.visible = false

				cloud2.position.set(0, -3000, 15000);
				cloud2.rotation.set(0, 0, Math.PI / 3)
				cloud2.scale.set(50, 50, 50)
				cloud2.visible = false
				
				BDVar.cloudGroup = new THREE.Group()
				BDVar.cloudGroup.add(cloud)
				BDVar.cloudGroup.add(cloud2)
				this.initPost( cloud, cloud2, paramGodRay, paramCloud)

				BDVar.scene.add(BDVar.cloudGroup)
				
				this.createShaderEarth();
				canvasDom = document.getElementsByTagName('canvas')[0]
				
				window.addEventListener( 'resize', function(e){
					_this.resetSize(e)
				} );
			},
			resetSize(e){
				if(window.innerWidth>1920){
					BDVar.renderer.setSize(window.innerWidth, container.offsetHeight);
				}else if(window.innerWidth>1200 && window.innerWidth<=1920){
					BDVar.renderer.setSize(window.innerWidth, 886);
				}else{
					BDVar.renderer.setSize(1200, 886);
				}
			},
			cloud(imageLoader) {
				var cloudMap = imageLoader.load(require('@/assets/cloud2.png'));
				var cloudGeo = new THREE.PlaneGeometry(500, 500);
				var cloudMaterial = new THREE.MeshBasicMaterial({
					map: cloudMap,
					transparent: true,
					side: THREE.DoubleSide,
					// flatShading: false,
					// depthTest:false,
					// opacity:0.3
				});

				let cloud = new THREE.Mesh(cloudGeo, cloudMaterial);
				return cloud
			},
			initPost(cloud, cloud2, param, param2) {
				let godraysEffectCloud = new GodRaysEffect(BDVar.camera, cloud, param2)
				let godraysEffectCloud2 = new GodRaysEffect(BDVar.camera, cloud2, param2)
				let renderPass = new RP(BDVar.scene, BDVar.camera);
				let effectPassCloud = new EffectPass(BDVar.camera, godraysEffectCloud);
				let effectPassCloud2 = new EffectPass(BDVar.camera, godraysEffectCloud2);
				let effectBloomPass = new EffectPass(
					BDVar.camera,
					new BloomEffect({
						intensity: 0
					})
				);

				// effectPass.renderToScreen = true;
				BDVar.composer = new EC(BDVar.renderer);
				BDVar.composer.addPass(renderPass);
				// BDVar.composer.addPass(effectPassCloud);
				// BDVar.composer.addPass(effectPassCloud2);
				// BDVar.composer.addPass(effectBloomPass);

			},
			addLight() {
				const directionalLight = new THREE.DirectionalLight(0xffffff, 2);
				BDVar.scene.add(directionalLight);
				directionalLight.position.set(-5000, 2000, -1000)
				const helper = new THREE.DirectionalLightHelper(directionalLight, 5);
				// BDVar.camera.add( helper );

				const directionalLight2 = new THREE.DirectionalLight(0xffffff, 0.5);
				BDVar.scene.add(directionalLight2);
				directionalLight2.position.set(0, -2000, 0)
				const helper2 = new THREE.DirectionalLightHelper(directionalLight2, 5);
				// BDVar.camera.add( helper2 );

				const directionalLight3 = new THREE.DirectionalLight(0xffffff, 0.5);
				BDVar.scene.add(directionalLight3);
				directionalLight3.position.set(5000, -2000, 0)
				// const helper3 = new THREE.DirectionalLightHelper(directionalLight3, 5);

				

			},
			animation() {
				const delta = BDVar.clock.getDelta();
				BDVar.cameraControls.update(delta);

				
				
				if (BDVar.composer) {
					// BDVar.composer.setSize(window.innerWidth, window.innerHeight);
					BDVar.composer.render()
				} else {
					BDVar.renderer.render(BDVar.scene, BDVar.camera); //用了后期渲染，不再用这个render了，新的render在postProc.js里，相关设置转移到该文件里设置
				}
				// BDVar.stats.end();
				if(uniforms && uniforms.u_time){
					uniforms.u_time.value += delta;
				}
				if(BDVar.earth1 && BDVar.earth2){
					BDVar.earth1.rotation.y += delta*0.1
					BDVar.earth2.rotation.y -= delta*0.05
				}
				var pos = BDVar.camera.position
				requestAnimationFrame(this.animation);
				
				if(canvasDom){
					const canvas = BDVar.renderer.domElement;
					BDVar.camera.aspect = canvas.clientWidth / canvas.clientHeight;
					BDVar.camera.updateProjectionMatrix();
				}
			},
			createShaderEarth(){
				const vs = `
				varying vec2 vUv;
					void main() {
						vUv = uv;
						vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );
					    gl_Position = projectionMatrix * mvPosition;
					}
				`;
				
				const fs = `
					#define TWO_PI 6.28318530718
					uniform vec2 u_resolution;
					uniform float u_time;
					uniform sampler2D u_texture;
					varying vec2 vUv;
					float circle(in vec2 st,in float r){
						vec2 len = st - vec2(0.5);//像素到中心点距离
						return 1.0 - smoothstep(
							r - (r*0.1),
							r + (r*0.1),
							dot(len,len)*4.0
						);
					}
					vec2 random2( vec2 p ) {
					    return fract(sin(vec2(dot(p,vec2(127.1,311.7)),dot(p,vec2(269.5,183.3))))*43758.5453);
					}
					void main(){
						vec2 st = vUv;
						vec2 myVUv = vUv;
						vec3 color = vec3(0.0);
						
						st.x *= 1.5;
						
						st *= 300.0;
						
						    vec2 i_st = floor(st);
						    vec2 f_st = fract(st);
						
						    float m_dist = 1.;  
						
						    for (int y= -1; y <= 1; y++) {
						        for (int x= -1; x <= 1; x++) {
						            vec2 neighbor = vec2(float(x),float(y));
						            vec2 point = random2(i_st + neighbor);
						            point = 0.5 + 0.5*sin(u_time + 6.2831*point);
						            vec2 diff = neighbor + point - f_st;
						            float dist = length(diff);
						            m_dist = min(m_dist, dist);
						        }
						    }
						
						    // 绘制中心点
						    color += 1.-step(.2, m_dist);
						
						
						if(color.b == 0.0){
							discard;
						}
						
						vec4 color2 = texture2D(u_texture,myVUv);
						if(color2.a>0.0){
							// color2.a = 0.5;
							color2.r = 0.4 ;
							color2.g = 0.4 ;
							color2.b = 0.9 ;
						}else{
							discard;
						}
						vec3 combColor = vec3(color.r + color2.r,color.g+color2.g,color.b+color2.b);
						float alpha = color2.a;
						float guang = myVUv.y; //外层地球可以让alpha相乘，越靠近中间越透明
						
						if(combColor.r>0.0){
							combColor = vec3(0.0,0.6,0.9);
						}
						gl_FragColor = vec4(combColor,alpha  * guang );
					
					}
				`;
				
				const fs2 = `
					#define TWO_PI 6.28318530718
					uniform vec2 u_resolution;
					uniform float u_time;
					uniform sampler2D u_texture;
					varying vec2 vUv;
					float circle(in vec2 st,in float r){
						vec2 len = st - vec2(0.5);//像素到中心点距离
						return 1.0 - smoothstep(
							r - (r*0.1),
							r + (r*0.1),
							dot(len,len)*4.0
						);
					}
					void main(){
						vec2 st = vUv;
						vec2 myVUv = vUv;
						vec3 color = vec3(0.0);
						
						st.x *= 1.5;
						
						st *= 400.0;
						//+ step就产生周期效果，1.0为周期
						st.x += step(1.0,mod(st.y,2.0)) * 0.5;//奇偶行偏移
						st = fract(st);
						// color = vec3(st,0.0);
						color = vec3(0.0,0.5,circle(st,0.4));
						
						if(color.b == 0.0){
							discard;
						}
						
						vec4 color2 = texture2D(u_texture,myVUv);
						if(color2.a>0.0){
							color2.a = 0.5;
							color2.r = 0.4 ;
							color2.g = 0.4 ;
							color2.b = 0.4 ;
						}
						vec3 combColor = vec3(color.r + color2.r,color.g+color2.g,color.b+color2.b);
						float alpha = color2.a;
						float guang = abs(myVUv.y - 0.5); //外层地球可以让alpha相乘，越靠近中间越透明
						gl_FragColor = vec4(combColor,alpha * guang );
					
					}
				`;
				
				let loader = new THREE.TextureLoader();
				loader.load(
				            //图片路径    
				            require('@/assets/earth.png'),
				            function (texture) {
									uniforms = {
				                	u_time: {
				                		type: "f",
				                		value: 1.0
				                	},
				                	u_resolution: {
				                		type: "v2",
				                		value: new THREE.Vector2()
				                	},
				                	u_texture: {
				                		value:texture
				                	}
				                };
								var material = new THREE.ShaderMaterial({
									uniforms: uniforms,
									vertexShader: vs,
									fragmentShader: fs,
									transparent: true,
									side: THREE.DoubleSide
								});
								
								//地球内
								const geometry = new THREE.SphereGeometry( 200, 20, 20 );
								const sphere = new THREE.Mesh( geometry, material );
								BDVar.scene.add( sphere );
								
								//地球外
								var material2 = new THREE.ShaderMaterial({
									uniforms: uniforms,
									vertexShader: vs,
									fragmentShader: fs2,
									transparent: true,
									side: THREE.DoubleSide
								});
								const geometry2 = new THREE.SphereGeometry( 250, 20, 20 );
								const sphere2 = new THREE.Mesh( geometry2, material2 );
								BDVar.scene.add( sphere2 );
								BDVar.earth1 = sphere
								BDVar.earth2 = sphere2
				            },
				            undefined,
				            function (err) {
				                console: error('发生错误');
				            }
				        ); 
				
				
				
				
				
			},
			render() {

				shadowCameraHelper.update();
			}

		}
	}
</script>

<style scoped>
.hello{
	width: 1920px;
	height: 100%;
}

</style>
